import { defineComponent, computed } from "vue";
import i18n from "../../locales/index.mjs";
import { isMobile } from "../../utils/environment.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { storeToRefs } from "pinia";
import SvgIcon from "./base/SvgIcon.vue.mjs";
import LogoOfPCInChineseBlackIcon from "./icons/LogoOfPCInChineseBlackIcon.vue.mjs";
import LogoOfPCInChineseWhiteIcon from "./icons/LogoOfPCInChineseWhiteIcon.vue.mjs";
import LogoOfMobileInChinese from "./icons/LogoOfMobileInChinese.vue.mjs";
import LogoTitleOfMobileInChinese from "./icons/LogoTitleOfMobileInChinese.vue.mjs";
import LogoInEnglish from "./icons/LogoInEnglish.vue.mjs";
import LogoTitleInEnglish from "./icons/LogoTitleInEnglish.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Logo",
  setup(__props) {
    const basicStore = useBasicStore();
    const { defaultTheme } = storeToRefs(basicStore);
    const isEN = computed(() => i18n.global.locale.value === "en-US");
    const isZH = computed(() => i18n.global.locale.value === "zh-CN");
    const isBlackTheme = computed(() => defaultTheme.value === "black");
    const isWhiteTheme = computed(() => defaultTheme.value === "white");
    return { __sfc: true, basicStore, defaultTheme, isEN, isZH, isBlackTheme, isWhiteTheme, isMobile, SvgIcon, LogoOfPCInChineseBlackIcon, LogoOfPCInChineseWhiteIcon, LogoOfMobileInChinese, LogoTitleOfMobileInChinese, LogoInEnglish, LogoTitleInEnglish };
  }
});
export {
  _sfc_main as default
};
